import {
  Box,
  Inline,
  Secondary,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import { format } from 'date-fns/format';

interface DateRendererProps {
  inputDate: string;
  updatedDate?: string;
}

export const DateRenderer = ({ inputDate, updatedDate }: DateRendererProps) => {
  const date = new Date(inputDate);

  const dateOnlyString = format(date, 'dd-MMM-yyyy');
  const visibleDate = dateOnlyString;

  const message = updatedDate ? (
    <Text size="small">
      Last updated {format(new Date(updatedDate), "EEEE do 'of' LLLL, yyyy")}
    </Text>
  ) : (
    <Text size="small">{visibleDate}</Text>
  );

  return (
    <TooltipRenderer id={`dateTooltip-${dateOnlyString}`} tooltip={message}>
      {({ triggerProps }) => (
        <Inline space="none">
          <Box {...triggerProps}>
            <Text>
              <Secondary>{visibleDate}</Secondary>
            </Text>
          </Box>
        </Inline>
      )}
    </TooltipRenderer>
  );
};
